module.exports = __webpack_public_path__ + "img/organization-panel-info.eff3c716.png";